import request, { authOptions } from 'api/requestUtils'
import type { definitions } from '@luxuryescapes/contract-svc-agent'

type DismissSocieteMembershipRequest = definitions['dismissSocieteMembershipRequest']
type DismissSocieteMembershipResponse = {
  success: boolean
}

export interface DismissSocieteMembershipParams {
  dismissType: 'login' | 'checkout'
}

async function requestPostDismissSocieteMembership(params: DismissSocieteMembershipParams) {
  const requestBody: DismissSocieteMembershipRequest = {
    dismissType: params.dismissType,
  }

  const response = await request.post<App.ApiResponse<DismissSocieteMembershipResponse>, DismissSocieteMembershipRequest>(
    '/api/agent/user/societe/dismiss',
    requestBody,
    authOptions(),
  )

  return response.result
}

export default requestPostDismissSocieteMembership
